/**
 * Only app-internal paths, never `//host`, `/\host` (browsers read both as another host) or
 * absolute URLs (open redirect).
 */
export function safeRedirect(target: string | undefined): string {
  if (target === undefined || !/^\/(?![/\\])/.test(target)) return '/';
  if (target.startsWith('/login') || target.startsWith('/setup-2fa')) return '/';
  return target;
}
